import request from '@/plugin/axios'

export function getMyAuth(data) {
  return request({
    url: '/api/admin/queryLoginUserRoleAuthList',
    method: 'put',
    data: data
  })
}
export function getAllAuths() {
  return request({
    url: '/api/s-auths/allAuth',
    method: 'get'
  })
}
export function getRoleAuth(data) {
  return request({
    url: '/api/admin/queryAuthListByRole',
    method: 'get',
    params: data
  })
}